import request from '@/utils/request'

// 获取列表
export function getAwardManList(data) {
  return request({
    url: '/admin/activity/webAwardMan/list',
    method: 'post',
    data
  })
}

// 添加
export function addAwardMan(data) {
  return request({
    url: '/admin/activity/webAwardMan/add',
    method: 'post',
    data
  })
}

// 修改
export function updateAwardMan(data) {
  return request({
    url: '/admin/activity/webAwardMan/edit',
    method: 'post',
    data
  })
}

// 删除
export function removeAwardMan(data) {
  return request({
    url: '/admin/activity/webAwardMan/remove',
    method: 'post',
    data
  })
}
